// @flow
import $ from 'jquery';
import JQueryView, { on } from '../common/JQueryView';

export default class ListView extends JQueryView {
  scope: string;
  rootTags: Object;
  subTags: Object;

  constructor(scope: string) {
    super(scope);
    this.rootTags = {};
    this.subTags = {};

    $(function() {
      $('.index').click(function(event) {
        if (
          !$(event.target)
            .attr('class')
            .match(/tag/)
        ) {
          if ($('.tag-cateroy-wrapper').css('display') == 'block') {
            $('.tag-cateroy-wrapper').hide();
          }
        }
      });
    });
  }

  @on({ event: 'click', selector: 'tr[data-href]' })
  onClickTr(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.open($(e.currentTarget).data('href'), '_blank');
  }

  @on({ event: 'keypress', selector: '#q_name_or_representative_cont' })
  onKeyPress(event: any) {
    const key = event.keyCode || event.charCode || 0;
    // 13はEnterキーのキーコード
    if (key == 13) {
      event.preventDefault();
      const tag_names = $('.sub-category.active .tag-name')
        .map(function() {
          return $(this)
            .text()
            .trim();
        })
        .get();
      $.ajax({
        url: event.target.href,
        type: 'get',
        data: {
          q: {
            tags_name_eq_any: tag_names,
            name_or_representative_cont: $(
              '#q_name_or_representative_cont',
            ).val(),
          },
        },
        dataType: 'script',
      });
    }
  }

  @on({ event: 'keypress', selector: '#q_tags_name_eq_any' })
  onKeyPressTag(event: any) {
    event.preventDefault();
  }

  @on({ event: 'focus', selector: '#q_tags_name_eq_any' })
  toggleTagCateroyWrapper() {
    $('.tag-cateroy-wrapper').show();
  }

  @on({ event: 'click', selector: '.root-category' })
  onClickRootCateogory(event: any) {
    let clickedBtn = $(event.target);
    if ($(event.target).hasClass('tag-name')) {
      clickedBtn = $(event.target).parent();
    }
    const dataId = clickedBtn.data('id');
    const rootIds = Object.keys(this.rootTags);

    const index = rootIds.indexOf(String(dataId));

    // 選択された状態でクリックされた場合, 解除する
    if (
      $('.root-category.active.selected').length > 0 &&
      $('.root-category.active.selected').data('id') == dataId
    ) {
      $(clickedBtn)
        .find('.counter')
        .hide();
      clickedBtn.removeClass('selected active');
      $(`div.sub-category.active[data-parent-id=${dataId}]`).removeClass(
        'selected active',
      );
      $('.sub-tag-category-wrapper').hide();

      if (index > -1) {
        delete this.rootTags[dataId]; // rootTags から削除
        delete this.subTags[dataId]; // subTags から削除
      }

      return;
    }

    // active にする
    $('.root-category.active.selected').removeClass('active');
    clickedBtn.addClass('active');

    // 初めて選択された場合
    if (index == -1) {
      clickedBtn.addClass('selected');
      this.rootTags[dataId] = $(clickedBtn)
        .find('.tag-name')
        .text()
        .trim();
      this.subTags[dataId] = [];
    }

    $.ajax({
      url: '/tag_categories/' + dataId,
      type: 'get',
      dataType: 'script',
    })
      .done(() => {
        this.subTags[dataId].forEach(tag => {
          $(`.sub-category.tag-name-btn[data-id=${tag.id}]`).addClass('active');
        });
      })
      .fail(() => {
        alert('エラーが起こりました');
      });
  }

  @on({ event: 'click', selector: '.sub-category' })
  onClickSubCateogory(event: any) {
    let clickedBtn = $(event.target);
    if ($(event.target).hasClass('tag-name')) {
      clickedBtn = $(event.target).parent();
    }

    const parentId = clickedBtn.data('parent-id');
    const id = clickedBtn.data('id');

    if (clickedBtn.hasClass('active')) {
      this.subTags[parentId] = this.subTags[parentId].filter(
        tag => tag.id != id,
      );
    } else {
      this.subTags[parentId].push({
        id: id,
        name: $(clickedBtn)
          .find('.tag-name')
          .text()
          .trim(),
      });
    }

    clickedBtn.toggleClass('active');

    const length = $(`.sub-category.active span[data-parent-id=${parentId}]`)
      .length;
    const counter = $(`.tag-name[data-id=${parentId}]`).siblings('.counter');
    if (length == 0) {
      counter.hide();
    } else {
      counter.show().text(length);
    }
  }

  @on({ event: 'click', selector: '.search-btn' })
  onClickSearchBtn(event: any) {
    event.preventDefault();

    let tag_names = [];
    let tag_names_text = [];
    let rootIdsWithoutSub = [];

    Object.keys(this.subTags).forEach(id => {
      //when only root category is selected
      if (this.subTags[id].length == 0) {
        rootIdsWithoutSub.push(id);
        tag_names_text.push(this.rootTags[id]);
      } else {
        tag_names = tag_names.concat(this.subTags[id].map(tag => tag.name));
        tag_names_text.push(
          this.rootTags[id] +
            ':' +
            this.subTags[id].map(tag => tag.name).join(','),
        );
      }
    });

    $('#q_tags_name_eq_any').val(tag_names_text.join(' | '));

    $.ajax({
      url: event.target.href,
      type: 'get',
      data: {
        root_tag_category_ids: rootIdsWithoutSub,
        q: {
          tags_name_eq_any: tag_names,
          name_or_representative_cont: $(
            '#q_name_or_representative_cont',
          ).val(),
        },
      },
      dataType: 'script',
    });
    $('.tag-cateroy-wrapper').hide();
  }

  @on({ event: 'click', selector: '.page-link' })
  onClickPageLink(event: any) {
    event.preventDefault();
    $.ajax({
      url: event.target.href,
      type: 'get',
      dataType: 'script',
    });
  }
}
